<template>
  <div class="container">
    <b-modal
        :model-value="modalEditar"
        :no-close-on-backdrop="true"
        hide-footer
        hide-header-close
        centered
        :title="labels.title"
        header-class="reset-modal-header"
        title-class="reset-modal-title"
        body-class="reset-modal-body"
        class="reset-password-dialog"
    >
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-3">
                <div class="password-policy-title">
                    {{ labels.formInfoTitle }}
                </div>
                <div class="password-policy-item">
                    {{ labels.formInfoSubtitle }}
                </div>
            </div>
            <b-col md="4" lg="12" class="p-0 mx-auto">
                <b-form-group>
                    <label>{{ labels.codigo }}</label>
                    <p>{{ form.tipo_tasa }}</p>
                    <label>{{ labels.descripcion }}</label>
                    <b-form-input
                        v-model="form.descripcion"
                        type="text"
                        class="reset-input"
                    ></b-form-input>
                    <label>{{ labels.frecuencia }}</label>
                    <b-form-input
                        v-model="form.frecuencia"
                        type="text"
                        class="reset-input"
                    ></b-form-input>
                    <label>{{ labels.modalidad }}</label>
                    <b-form-select v-model="form.modalidad" class="reset-input" autocomplete="off">
                        <option value="">{{ labels.select }}</option> 
                        <option value="A">{{ labels.anticipada }}</option> 
                        <option value="F">{{ labels.fija }}</option> 
                        <option value="V">{{ labels.vencida }}</option> 
                    </b-form-select>
                </b-form-group>
                <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                    <b-button
                        class="reset-btn-delete me-auto"
                        @click="eliminaRegistro()"
                    >
                        {{ labels.delete }}
                    </b-button>
                    <b-button
                        class="mr-2 reset-btn-secondary"
                        @click="cierraModal()"
                    >
                        {{ labels.close }}
                    </b-button>
                    <b-button
                        class="reset-btn-primary"
                        @click="guardarTipoTasa()"
                    >
                        {{ labels.save }}
                    </b-button>
                </div>
            </b-col>
        </div>
    </b-modal>
    <InacticaItem :InactivaItem="deleteTipoTasa" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
  </div>
</template>

<script>

import TipoTasa from '../../../services/TipoTasas'; 
import InacticaItem from '../../utils/InacticaItem'; 

export default {
    name : 'Editar',
    props: {
        modalEditar: {
            type: Boolean,
            required: true
        },
        infoTipoTasa: {
            type: Object,
            default: () => ({})
        }
    },
    components:{InacticaItem},
    data() {
        return {
            form: {
                id: null,
                tipo_tasa: "",
                descripcion: "",
                frecuencia: "",
                modalidad: ""
            },
            deleteTipoTasa: false,
            idTipoTasa: null
        };
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Editar tipo tasa',
                    delete : 'Eliminar',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    frecuencia : 'Frecuencia',
                    modalidad : 'Modalidad',
                    select : 'Seleccione...', 
                    anticipada : 'Anticipada',
                    fija : 'Fija',
                    vencida : 'Vencida',
                    formInfoTitle: "Datos del tipo de tasa",
                    formInfoSubtitle: "Actualiza la información del tipo de tasa y guarda los cambios."
                }
            }else{
                return {
                    title : 'Edit rate type',
                    delete : 'Delete',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code',
                    descripcion : 'Description',
                    frecuencia : 'Frecuency',
                    modalidad : 'Type',
                    select : 'Select...', 
                    anticipada : 'Anticipated',
                    fija : 'Fixed',
                    vencida : 'Expire',
                    formInfoTitle: "Rate type data",
                    formInfoSubtitle: "Update the third type information and save the changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        cierraModalDelet(){
            this.deleteTipoTasa = false 
        },
        guardarTipoTasa(){
            if (
                !this.form.descripcion.trim() ||
                !this.form.frecuencia ||
                !this.form.modalidad
            ) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }
                
            const info = {
                id: this.form.id,
                codigo: this.form.tipo_tasa,
                descripcion: this.form.descripcion,
                frecuencia: this.form.frecuencia,
                modalidad: this.form.modalidad,
                idUser: this.$store.state.userId
            };
            
            TipoTasa.updateTipoTasaById(info) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("actualizado");
                    this.cierraModal();
                
                }else if(res.status == 204){ 
                    this.$toast.error('Tipo tasa ingresada ya existe.') 
                }
            })
            .catch((error) => {
                console.error(error);
                this.$toast.error("Ocurrió un error al guardar.");
            });
        },
        eliminaRegistro(){
            this.idTipoTasa = this.form.id 
            this.deleteTipoTasa = true 
        },
        confirmInactivate(){
            TipoTasa.deleteTipoTasa(this.idTipoTasa) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 

                    this.$emit("eliminado");
                    this.cierraModalDelet();
                    this.cierraModal();
                }
            })
            .catch((error) => {
                console.error(error);
                this.$toast.error("Ocurrió un error al eliminar.");
            });
        }
    },
    watch: {
        infoTipoTasa: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.form = { ...value };
                }
            }
        }
    },
}
</script>

<style>

</style>
